import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

import { Store } from '../../store'

@ngCore.Component({
  imports: [ngRouter.RouterLink, ngCommon.NgTemplateOutlet],
  selector: 'atn-navbar-footer-item',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /**
   * Determines which icon is shown (only include the portion after `atn-`)
   *
   * @example
   * 'log-out'
   * 'folder'
   * 'clipboard'
   */
  public readonly iconSg = ngCore.input.required<string>({
    alias: 'icon',
  })

  /**
   * Shown when expanded
   */
  public readonly nameSg = ngCore.input.required<string>({
    alias: 'name',
  })

  /**
   * External (outside the current Angular SPA) link to navigate to
   *
   * @see {@link internalUrlSg}
   */
  public readonly externalUrlSg = ngCore.input<string | undefined>(undefined, {
    alias: 'externalUrl',
  })

  /**
   * Internal (within the current Angular SPA) link to navigate to
   *
   * @see {@link externalUrlSg}
   */
  public readonly internalUrlSg = ngCore.input<string | undefined>(undefined, {
    alias: 'internalUrl',
  })

  /**
   * Optional icon to display as a suffix after the name text (only include the
   * portion after `atn-`).
   * Commonly used to indicate additional context like external links or
   * expandable items.
   */
  public readonly suffixIconSg = ngCore.input<string | undefined>(undefined, {
    alias: 'suffixIcon',
  })
}
